import * as React from "react";
import { Grid, Form } from "semantic-ui-react";
import { LinkObject } from "@teamprevent/common/model";

import { connect } from "react-redux";

import { ApplicationState } from "../../applicationState";
import { immunisationTypeTasksSelector } from "../../crud/immunisationTypeTask/selectors";
import { ImmunisationTypeTask } from "../../crud/immunisationTypeTask";

import { ImmunisationTypeTaskSelector } from "./ImmunisationTypeTaskSelector";

interface OwnProps {
    selectedTypes: LinkObject[];
    addMoreButtonText: string;
    onSelectionChanged: (selection: LinkObject[]) => void;
    taskTypeFilter?: string;
}

interface StateProps {
    availableTypes: ImmunisationTypeTask[];
}

type Props = OwnProps & StateProps;

export const ImmunisationTypeTasksSelectorUnconnected: React.FunctionComponent<Props> = (props) => {
    const onSelectionChanged = (index: number, selection: LinkObject) => {
        props.onSelectionChanged(props.selectedTypes.map((t, i) => i === index ? selection : t));
    };

    const onAddImmunisationTypeTask = () => {
        props.onSelectionChanged([...props.selectedTypes, null]);
    };

    const isAlreadySelected = (item: ImmunisationTypeTask, index: number) => {
        const otherSelections = props.selectedTypes.filter((o, i) => i !== index);
        return otherSelections.some(s => s && s.id === item.id);
    };

    return (
        <>
            <Grid>
                {props.selectedTypes.map((selectedImmunisationTypeTask, index) => (
                    <ImmunisationTypeTaskSelector
                        key={index}
                        selectedType={selectedImmunisationTypeTask}
                        onSelectionChanged={selection => onSelectionChanged(index, selection)}
                        availableTypes={props.availableTypes.filter(t => !isAlreadySelected(t, index)).map(t => ({ id: t.id, name: t.name }))}
                        onRemove={() => props.onSelectionChanged(props.selectedTypes.filter((o, i) => i !== index))}
                    />
                ))}
                <Grid.Row>
                    <Grid.Column>
                        <Form.Button type="button" icon="add" content={props.addMoreButtonText} onClick={onAddImmunisationTypeTask} />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </>
    );
};

const mapStateToProps = (state: ApplicationState): StateProps => ({
    availableTypes: immunisationTypeTasksSelector(state)
});

const mergeProps = (stateProps: StateProps, dispatchProps: any, ownProps: OwnProps): Props => ({
    ...stateProps,
    ...ownProps,
    availableTypes: stateProps.availableTypes.filter(t => !ownProps.taskTypeFilter || t.taskType === ownProps.taskTypeFilter)
});

export const ImmunisationTypeTasksSelector = connect(mapStateToProps, null, mergeProps)(ImmunisationTypeTasksSelectorUnconnected);
